import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import { APP_COLOR, FONT_FAMILY, NAVBAR_AND_FOOTER_BACKGROUND_COLOR } from "../../theme";

export const styles = {
  footerContainer: {
    backgroundColor: NAVBAR_AND_FOOTER_BACKGROUND_COLOR,
    paddingBottom: 1,
  } as const,
  leftSideFooter: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "flex-start",
    flexGrow: 1,
    gap: "15%",
    padding: "30px 30px 50px 30px",
  } as const,
  footerHeader: {
    fontWeight: "bold",
    color: APP_COLOR,
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
  } as const,
  footerRights: {
    color: APP_COLOR,
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
  } as const,
  icon: {
    color: "white",
    width: "40px",
    height: "40px",
    marginRight: "15px",
  },
};

export const FooterInnerContainer = styled(Box)(({ theme }) => ({
  height: "auto",
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    padding: "0 5px",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "0 20px",
  },
}));

export const RightSideFooter = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "30px 30px 50px 30px",
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    justifyContent: "flex-start",
    padding: "0 30px 30px",
  },
  [theme.breakpoints.up("sm")]: {
    justifyContent: "flex-end",
  },
}));

export const FooterOmmuseRights = styled(Box)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    padding: "0 35px",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "0 50px",
    marginTop: 30,
  },
}));
